// Website Creator: htutkhaung.ko@msgtech.co.th
import { TRANSLATIONS } from './translations.js';

const STORAGE_KEY = 'msgtech_lang';
const DEFAULT_LANG = 'th'; // Thai as default per user requirement

let currentLang = DEFAULT_LANG;

export function getLanguage() {
  return currentLang;
}

export function t(key, fallback = '') {
  const dict = TRANSLATIONS[currentLang] || TRANSLATIONS[DEFAULT_LANG];
  return dict[key] !== undefined ? dict[key] : (fallback || key);
}

export function setLanguage(lang) {
  if (lang !== 'th' && lang !== 'en') {
    lang = DEFAULT_LANG;
  }
  currentLang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {}

  document.documentElement.lang = lang;
  applyTranslations();

  // Dispatch event for dynamic modules (e.g. mala-scale-sim, solutions, contact)
  window.dispatchEvent(new CustomEvent('msgtech_lang_changed', { detail: { lang } }));
}

export function toggleLanguage() {
  const nextLang = currentLang === 'th' ? 'en' : 'th';
  setLanguage(nextLang);
}

export function applyTranslations() {
  const dict = TRANSLATIONS[currentLang] || TRANSLATIONS[DEFAULT_LANG];

  // 1. Text elements with data-i18n
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (dict[key] !== undefined) {
      el.textContent = dict[key];
    }
  });

  // 2. Elements with HTML formatting data-i18n-html
  document.querySelectorAll('[data-i18n-html]').forEach(el => {
    const key = el.getAttribute('data-i18n-html');
    if (dict[key] !== undefined) {
      el.innerHTML = dict[key];
    }
  });

  // 3. Input and textarea placeholders with data-i18n-placeholder
  document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
    const key = el.getAttribute('data-i18n-placeholder');
    if (dict[key] !== undefined) {
      el.setAttribute('placeholder', dict[key]);
    }
  });

  // 4. Update language toggle buttons in desktop navbar and mobile drawer
  document.querySelectorAll('.lang-toggle-btn').forEach(btn => {
    const labelSpan = btn.querySelector('.lang-label-text');
    if (labelSpan) {
      labelSpan.textContent = currentLang.toUpperCase();
    }
    btn.setAttribute('aria-label', dict['nav.lang_toggle_label'] || 'Switch Language');
    btn.setAttribute('title', dict['nav.lang_toggle_label'] || 'Switch Language');
  });
}

export function initI18n() {
  // Read saved preference or default to Thai ('th')
  let saved = DEFAULT_LANG;
  try {
    saved = localStorage.getItem(STORAGE_KEY) || DEFAULT_LANG;
  } catch (e) {
    saved = DEFAULT_LANG;
  }

  currentLang = saved === 'en' ? 'en' : 'th';
  document.documentElement.lang = currentLang;

  // Bind click listeners on all language toggle buttons
  document.querySelectorAll('.lang-toggle-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleLanguage();
    });
  });

  applyTranslations();
}
